import { Component, AfterViewInit } from '@angular/core';
import { DmarService } from 'app/services/dmar.service';
import { CrsUnsubscriberComponent } from 'app/signon/crs-unsubscriber.component';
import { takeUntil } from 'rxjs/operators';

@Component({
  selector: 'disclosure-banner',
  templateUrl: './disclosure-banner.component.html'
})
export class DisclosureBannerComponent extends CrsUnsubscriberComponent implements AfterViewInit {

  disclosureText: any;
  primaryDisclosureArray: Array<any> = []; 
  secondaryDisclosureArray: Array<any> = []; 
  flexDisclosureArray: Array<any> = [];
  isAdEnabled: Boolean;

  constructor(public dmarService: DmarService) {
	  super();
    // To get primary disclosure contents 
	this.dmarService.primaryDisclosure
	.pipe(takeUntil(this.unsubscribe$))
	.subscribe(text => { 
		for (let item in text.message) { 
		if (item.toLowerCase().includes('disclosure') && text.message[item] !== "") { 
		this.primaryDisclosureArray.push(text.message[item]); 
		} 
		} 
	}) 
	// To get secondary disclosure contents 
	this.dmarService.secondaryDisclosure
	.pipe(takeUntil(this.unsubscribe$))
	.subscribe(text => { 
		for (let item in text.message) { 
		if (item.toLowerCase().includes('disclosure') && text.message[item] !== "") { 
		this.secondaryDisclosureArray.push(text.message[item]); 
		} 
		} 
	}) 
	// To get flex disclosure contents 
	this.dmarService.flexDisclosure
	.pipe(takeUntil(this.unsubscribe$))
	.subscribe(text => { 
		for (let item in text.message) { 
		if (item.toLowerCase().includes('disclosure') && text.message[item] !== "") { 
		this.flexDisclosureArray.push(text.message[item]); 
		} 
		} 
	}) 
  }

  

  ngAfterViewInit() {
    setTimeout(() => {
     // this.isAdEnabled = this.dmarService.isAdBlockerEnabled();
      if (this.dmarService.isAdBlocking == true) {
        console.log("Ad enabled");
      }
    });
  }



}